import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  repeaterContainer: {
    flexDirection: ['column', 'row'],
    alignItems: 'center',
    margin: ['38px 0 87px 0', '0'],
  },
  itemContainer: {
    borderRadius: '12px',
    background: '#F2F2F2',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minHeight: ['390px', '492px'],
    width: ['322px', '484px'],
    margin: ['30px 26px', null, '70px 23px 70px', '139px 45px 140px'],
  },
  imageContainer: {
    width: ['199px', '249px'],
    minHeight: ['199px', '249px'],
    margin: 'auto',
    paddingTop: ['34px', '52px'],
    marginBottom: '24px',
  },
  plusContainer: {
    float: 'left',
    margin: [
      '18px 0 0 22px',
      null,
      '18px 0 0 22px',
      '18px 0 0 22px',
      '14px 0 0 64px',
    ],
    color: '#FDC10A',
  },
  textContainer: {
    textAlign: 'left',
    margin: [
      '27px 22px 0 14px',
      null,
      '27px 22px 0 14px',
      '27px 22px 0 14px',
      '27px 64px 0 14px',
    ],
    color: '#3E3B7C',
  },
  boxLink: {
    textDecoration: 'none',
  },
  linkLabelContainer: {
    margin: ['32px auto', '48px auto'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkLabelText: {
    display: 'inline-block',
    textTransform: 'uppercase',
    variant: 'backgrounds.gradient2',
    WebkitBackgroundClip: ['text'],
    WebkitTextFillColor: ['transparent'],
  },
  arrowIcon: {
    display: 'inline-block',
    marginLeft: '12px',
    width: '14px',
    path: {
      stroke: '#3E3B7C',
    },
  },
};
